import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      fill: _ctx.color,
      "fill-rule": "evenodd",
      d: "M10 10 h32 v32 h-32 z M20 20 h12 v12 h-12 z M58 10 h32 v32 h-32 z M68 20 h12 v12 h-12 z M10 58 h32 v32 h-32 z M20 68 h12 v12 h-12 z M44 44 h12 v12 h-12 z M62 62 h10 v10 h-10 z M76 62 h10 v10 h-10 z M62 76 h10 v10 h-10 z M76 76 h10 v10 h-10 z"
    }, null, 8, _hoisted_2)
  ]))
}